import React, { Component, Fragment } from 'react'
import gql from 'graphql-tag'
import MUIDataTable from 'mui-datatables'
import { withApollo } from 'react-apollo'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
// import { Select } from '@material-ui/core'
import Select from 'react-select'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar/withSharedSnackbar'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
// import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import getLoginId from '../../../utils/getLoginId'
import FormHelperText from '@material-ui/core/FormHelperText'
// import FileSaver from "file-saver";
// import ExcelJS from "exceljs";
// import * as XLSX from 'xlsx'
// import FileSaver from 'file-saver'
import Multiselect from 'multiselect-react-dropdown'

import { DatePicker } from 'material-ui-pickers'
// import {
//     MobileDateTimePicker,
//   } from "@mui/x-date-pickers";
import moment from 'moment'
// import { sync } from 'resolve'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'

const style = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  iconSmall: {
    fontSize: 20
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit
  },
  dense: {
    marginTop: 16
  },
  button: {
    margin: theme.spacing.unit * 1
  }
})

const GET_CLIENTS = gql`
  query allClientDetails($partnerLoginId: Int, $status: Int) {
    clientsDetails: allClientDetails(
      partnerLoginId: $partnerLoginId
      status: $status
    ) {
      clientName
      loginId
      partner {
        businessName
      }
    }
  }
`
const ALL_VEH = gql`
  query allClientDetails($partnerLoginId: Int) {
    allVehicles: getAllVehicleDetailsByStatus(
      partnerLoginId: $partnerLoginId
      status: 1
    ) {
      vehicleNumber
      clientLoginId
      deviceDetail {
        uniqueDeviceId
      }
    }
  }
`

const DETAILED_ALERTS_QUERY = gql`
  query getDetailedAlertsData(
    $clientLoginIds: [Int!]
    $startTime: Int
    $endTime: Int
    $vehicleNumbers: [String!]
    $useAlgo: String
    $rawDataPackets: Int
    $forAllVehicles: Boolean
  ) {
    getDetailedAlertsData(
      clientLoginIds: $clientLoginIds
      startTime: $startTime
      endTime: $endTime
      rawDataPackets: $rawDataPackets
      vehicleNumbers: $vehicleNumbers
      useAlgo: $useAlgo
      forAllVehicles: $forAllVehicles
    ) {
      vehicleNumber
      customerName
      eventId
      eventType
      eventVolume
      date
      startTime
      endTime
      startTimeStamp
      endTimeStamp
      totalDistance_duringEvent_mts
      totalDistance_betweenEvents_kms
      timeElapsed_duringEvent_min
      timeElapsed_betweenEvents_hrs
      averageSpeed_kmph
      currentStatus
      ignitionOnTime_min
      ignitionOffTime_min
      actualDataPackets
      idealDataPackets
      dataConsistency
      rawData {
        rawFuelLevel
        smoothFuelLevel
        timeStamp
        lat
        lng
        obdDistance
      }
    }
  }
`

export class DetailedAlerts extends Component {
  state = {
    detailedAlertsLoading: false,
    isLoading: false,
    selectedFormDate: new Date(),
    allVehicles: [],
    allVehiclesOption: [],
    rawData: [],
    clientsDetails: [],
    vehicleDetails: [],
    selectedClients: [],
    clientLoginIds: [],
    selectedVehicles: [],
    selectedUniqueIds: [],
    response: [],
    // getAllVeh: { id: false, label: 'false' },
    getAllVeh: 'true',
    useAlgo: null,
    rawDataPackets: 30,
    startTime: moment()
      .unix()
      .toString(),
    startDate: {
      date: moment(),
      unix: moment()
        .unix()
        .toString()
    },
    endDate: {
      date: moment(),
      unix: moment()
        .unix()
        .toString()
    },
    endTime: moment()
      .unix()
      .toString(),
    partnerLoginId: getLoginId()
  }
  columns = [
    {
      name: 'vehicleNumber',
      label: 'Vehicle Number'
    },
    {
      name: 'customerName',
      label: 'Customer Name'
    },
    {
      name: 'eventId',
      label: 'eventID'
    },
    {
      name: 'eventType',
      label: 'event Type'
      // dataType: 'number'
    },
    {
      name: 'eventVolume',
      label: 'Event Volume'
    },
    {
      name: 'date',
      label: 'Date'
    },
    {
      name: 'startTime',
      label: 'Start Time'
    },
    {
      name: 'endTime',
      label: 'End Time'
    },
    {
      name: 'startTimeStamp',
      label: 'Start Timestamp'
    },
    {
      name: 'endTimeStamp',
      label: 'End Timestamp'
    },
    {
      name: 'timeElapsed_duringEvent_min',
      label: 'Time Elapsed During_Event(Min)'
    },
    {
      name: 'timeElapsed_betweenEvents_hrs',
      label: 'TimeElapsed BetweenEvents(Hrs)',
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          let a
          if (value == null) a = 'No Next Event'
          else a = value
          return a
        }
      }
    },
    {
      name: 'totalDistance_duringEvent_mts',
      label: 'TotalDistance DuringEvent(mtrs)'
    },
    {
      name: 'totalDistance_betweenEvents_kms',
      label: 'TotalDistance BetweenEvents(Kms)',
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          let a
          if (value == null) a = 'No Next Event'
          else a = value
          return a
        }
      }
    },
    {
      name: 'averageSpeed_kmph',
      label: 'Average Speed(Kmph)',
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          let a
          if (value == null) a = 0
          else a = value
          return a
        }
      }
    },
    {
      name: 'currentStatus',
      label: 'Current Status'
    },
    {
      name: 'ignitionOnTime_min',
      label: 'ignitionOnTime(Min)'
    },
    {
      name: 'ignitionOffTime_min',
      label: 'ignitionOffTime(Min)'
    },
    {
      name: 'actualDataPackets',
      label: 'actualDataPackets'
    },
    {
      name: 'idealDataPackets',
      label: 'idealDataPackets'
    },
    {
      name: 'dataConsistency',
      label: 'dataConsistency'
    },
    {
      name: 'rawData',
      label: 'rawData',
      options: {
        display: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          // const rowData = tableMeta.rowData // Get the entire row's data
          // // Assuming value is an array of objects
          // const csvString = value
          //   .map(obj => Object.values(obj).join(', '))
          //   .join('\n')
          return (
            <button onClick={() => this.handleCellClick(value)}>
              Click Me
            </button>
          )
        }
      }
    }
  ]
  RawDatacolumns = [
    {
      label: 'Raw Fuel Level',
      name: 'rawFuelLevel'
    },
    {
      label: 'Smooth Fuel Level',
      name: 'smoothFuelLevel'
    },
    {
      label: 'Timestamp',
      name: 'timeStamp'
    },
    {
      label: 'Latitude',
      name: 'lat'
    },
    {
      label: 'Longitude',
      name: 'lng'
    },
    {
      label: 'OBD Distance',
      name: 'obdDistance'
    }
  ]

  handleCellClick(cellValue) {
    console.log(cellValue)
    this.setState({ rawData: cellValue })
  }
  handleFromDate = date => {
    this.setState({ selectedFormDate: date })
    var finalStart = moment(date).unix()
    this.setState({ fromDate: finalStart })

    var dateNow = new Date(date) // Now
    dateNow.setDate(dateNow.getDate() + 30)
    this.setState({ toMaxDate: dateNow })
  }
  options = {
    filter: true
  }
  handleSubmit = async () => {
    this.setState({ isLoading: true })
    const res = await this.props.client.query({
      query: DETAILED_ALERTS_QUERY,
      variables: {
        clientLoginIds: this.state.selectedClients,
        vehicleNumbers: this.state.selectedVehicles,
        startTime: parseInt(this.state.startTime),
        endTime: parseInt(this.state.endTime),
        rawDataPackets: parseInt(this.state.rawDataPackets),
        useAlgo: this.state.useAlgo == null ? null : this.state.useAlgo.id,
        forAllVehicles:
          this.state.getAllVeh === 'true' ? Boolean(true) : Boolean(false)
      },
      fetchPolicy: 'network-only'
    })
    let resData = res.data.getDetailedAlertsData
    this.setState({ response: resData, isLoading: false })
    console.log(resData)

    console.log(res)
  }

  getAllClients = async () => {
    const clientsDetails = await this.props.client.query({
      query: GET_CLIENTS,
      variables: {
        partnerLoginId: parseInt(this.state.partnerLoginId, 10),
        status: parseInt(1, 10)
      },
      fetchPolicy: 'network-only'
    })
    // console.log(clientsDetails)
    const allClients = clientsDetails.data.clientsDetails.map(client => ({
      name: client.loginId,
      label: client.clientName
    }))
    console.log(allClients)
    this.setState({ clientsDetails: allClients })
  }

  getAllVehicles = async () => {
    const allVehicles = await this.props.client.query({
      query: ALL_VEH,
      variables: {
        partnerLoginId: parseInt(this.state.partnerLoginId, 10)
      },
      fetchPolicy: 'network-only'
    })
    console.log(allVehicles.data.allVehicles)
    const allvehs = allVehicles.data.allVehicles.map(veh => ({
      value: veh.vehicleNumber,
      label: veh.vehicleNumber
    }))
    this.setState({
      allVehicles: allVehicles.data.allVehicles,
      allVehiclesOption: allvehs
    })
  }
  async componentDidMount() {
    this.getAllClients()
    this.getAllVehicles()
  }
  getVehicleDetails = async ids => {
    let clientLoginIds = ids
    console.log(clientLoginIds)
    if (clientLoginIds && clientLoginIds.length > 0) {
      let vehicleFiltered = this.state.allVehicles.filter(item =>
        clientLoginIds.includes(item.clientLoginId)
      )
      const filteredVeh = vehicleFiltered.map(veh => ({
        value: veh.vehicleNumber,
        label: veh.vehicleNumber
      }))
      console.log(filteredVeh)
      this.setState({ vehicleDetails: filteredVeh })
    }
  }

  handleChangeAlgo = event => {
    console.log(event)
    this.setState({ useAlgo: event })
  }
  // handleGetAll = event => {
  //   console.log(event.target.value)
  //   let a = event.target.value
  //   console.log(a)
  //   this.setState({ getAllVeh: a })
  // }
  handleGetAll = event => {
    const a = event.target.value;
    this.setState({ getAllVeh: a });
    if (a === 'true') {
      const nextDay = moment(this.state.startDate.date).add(1, 'days');
      this.setState({
        endDate: {
          date: nextDay,
          unix: nextDay.unix().toString()
        },
        endTime: nextDay.unix().toString()
      });
    }
  };
  

  // handleStartDateChange = name => date => {
  //   let tempDate = this.state[name]
  //   tempDate.date = date
  //   console.log(date)
  //   tempDate.unix = moment(date)
  //     .unix()
  //     .toString()
  //   this.setState({ [name]: tempDate, startTime: tempDate.unix })
  // }

  handleStartDateChange = name => date => {
    let tempDate = this.state[name]
    tempDate.date = date
    tempDate.unix = moment(date)
      .unix()
      .toString()
    this.setState({ [name]: tempDate, startTime: tempDate.unix })
    if (
      this.state.selectedVehicles.length === 0 ||
      this.state.getAllVeh === 'true'
    ) {
      const nextDay = moment(date).add(1, 'days')
      this.setState({
        endDate: {
          date: nextDay,
          unix: nextDay.unix().toString()
        },
        endTime: nextDay.unix().toString()
      })
    }
  }

  handleRawDataPacketsChange = event => {
    const value = event.target.value
    if (/^\d+$/.test(value) || value === '') {
      this.setState({ rawDataPackets: Number(value) })
    }
  }
  handleEndDateChange = name => date => {
    let tempDate = this.state[name]
    tempDate.date = date
    console.log(date)
    tempDate.unix = moment(date)
      .unix()
      .toString()
    this.setState({ [name]: tempDate, endTime: tempDate.unix })
  }

  handleClientRemove = (selectedList, removedItem) => {
    const updatedSelectedClients = selectedList.map(item => item.name)
    this.setState({
      selectedClients: updatedSelectedClients,
      selectedVehicles: []
    })
    this.getVehicleDetails(updatedSelectedClients)
  }

  handleClientSelect = (selectedList, selectedItem) => {
    const updatedSelectedClients = selectedList.map(item => item.name)
    this.setState({
      selectedClients: updatedSelectedClients,
      selectedVehicles: []
    })
    this.getVehicleDetails(updatedSelectedClients)
  }

  // handleVehicleRemove = (selectedList, removedItem) => {
  //   const updatedSelectedClients = selectedList.map(item => item.value)
  //   this.setState({ selectedVehicles: updatedSelectedClients })
  // }
  handleVehicleRemove = (selectedList, removedItem) => {
    const updatedSelectedClients = selectedList.map(item => item.name);
    this.setState({
      selectedClients: updatedSelectedClients,
      selectedVehicles: []
    });
  
    // Check if any vehicles are still selected, if not, update end date
    if (updatedSelectedClients.length === 0) {
      const nextDay = moment(this.state.startDate.date).add(1, 'days');
      this.setState({
        endDate: {
          date: nextDay,
          unix: nextDay.unix().toString()
        },
        endTime: nextDay.unix().toString()
      });
    } else {
      this.getVehicleDetails(updatedSelectedClients);
    }
  };

  handleVehicleSelect = (selectedList, selectedItem) => {
    const updatedSelectedClients = selectedList.map(item => item.value)
    this.setState({ selectedVehicles: updatedSelectedClients })
  }

  downloadExcel = (buildHead, buildBody, columns, data) => {
    console.log('in download excel function.....')

    const processedData = data.map(row => {
      const processedRow = { ...row }
      if (row.data && Array.isArray(row.data)) {
        const processedDataArray = row.data.map(
          item =>
            Array.isArray(item)
              ? // ? item.map(subItem => Object.values(subItem).join(' ')).join(',')
                JSON.stringify(item)
              : item === null
                ? 'NoNextEvent'
                : item
        )
        processedRow.data = processedDataArray
      }
      return processedRow
    })

    const csvContent = `${buildHead(columns)}\n${buildBody(processedData)}`
    const blob = new Blob([csvContent], { type: 'text/csv' })
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = 'exported_data.csv'
    link.click()
    window.URL.revokeObjectURL(link.href)
    link.remove()
    return false
  }

  render() {
    console.log(this.state)
    console.log(this.props)
    const { classes } = this.props
    const {
      detailedAlertsLoading,
      clientsDetails,
      selectedClients,
      useAlgo
    } = this.state
    return (
      <div className={classes.root}>
        <Typography variant="title" gutterBottom>
          <p>
            Detailed Alerts<br />
            <br />
          </p>
        </Typography>
        <Grid
          container
          spacing={16}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <Grid container style={{ display: 'flex', alignItems: 'center' }}>
            <Grid
              container
              className="searchdiv"
              spacing={8}
              justify="center"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Grid item xs={12} sm={12}>
                <label
                  style={{
                    marginRight: '20px'
                  }}
                >
                  Clinet LoginIDs :
                </label>

                <FormControl
                  style={{
                    minWidth: '50%'
                  }}
                >
                  <FormGroup className="form-input">
                    <Multiselect
                      displayValue="label"
                      onKeyPressFn={function noRefCheck() {}}
                      onSearch={function noRefCheck() {}}
                      onRemove={this.handleClientRemove}
                      onSelect={this.handleClientSelect}
                      options={this.state.clientsDetails}
                      placeholder="Select ClinetLoginIDs"
                      // style={{
                      //   chips: {
                      //     background: 'grey'
                      //   },
                      //   // searchBox: {
                      //   //   border: 'none',
                      //   //   'border-bottom': '1px solid blue',
                      //   //   'border-radius': '0px'
                      //   // }
                      // }}
                    />

                    <FormHelperText
                      id="name-error-text"
                      className="Error_msg"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12}>
                <label
                  style={{
                    marginRight: '20px'
                  }}
                >
                  Vehicle Numbers :
                </label>

                <FormControl
                  style={{
                    minWidth: '50%'
                  }}
                >
                  <FormGroup className="form-input">
                    <Multiselect
                      displayValue="label"
                      onKeyPressFn={function noRefCheck() {}}
                      onSearch={function noRefCheck() {}}
                      onRemove={this.handleVehicleRemove}
                      onSelect={this.handleVehicleSelect}
                      placeholder="Select Vehicles"
                      options={
                        this.state.selectedClients.length == 0
                          ? this.state.allVehiclesOption
                          : this.state.vehicleDetails
                      }
                    />

                    <FormHelperText
                      id="name-error-text"
                      className="Error_msg"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid item xs={12} sm={12} fullwidth="true">
                <label
                  style={{
                    marginRight: '20px'
                  }}
                >
                  Use Algo :
                </label>
                <FormControl
                  style={{
                    minWidth: '50%'
                  }}
                >
                  <FormGroup className="form-input">
                    <Select
                      classes={classes}
                      options={[
                        { id: 'taabi1', label: 'taabi1' },
                        { id: 'taabi3', label: 'taabi3' }
                      ]}
                      value={this.state.useAlgo}
                      onChange={this.handleChangeAlgo}
                      placeholder="Select Algorithm"
                    />

                    <FormHelperText
                      id="name-error-text"
                      className="Error_msg"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                fullwidth="true"
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <label
                  style={{
                    marginRight: '10px'
                  }}
                >
                  Get AllVehicles:
                </label>
                <FormControl
                  style={{
                    minWidth: '50%'
                  }}
                >
                  <FormGroup row className="form-input">
                    <RadioGroup
                      aria-label="getAllVeh"
                      name="getAllVeh"
                      value={this.state.getAllVeh}
                      onChange={this.handleGetAll}
                      row
                    >
                      <FormControlLabel
                        value={'true'}
                        control={<Radio />}
                        label="true"
                      />
                      <FormControlLabel
                        value={'false'}
                        control={<Radio />}
                        label="false"
                      />
                    </RadioGroup>
                    <FormHelperText
                      id="name-error-text"
                      className="Error_msg"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} fullwidth="true">
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <TextField
                      className="textfield"
                      type="number"
                      label="raw data packets"
                      value={this.state.rawDataPackets}
                      required
                      onChange={this.handleRawDataPacketsChange}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid item xs={12} sm={12} fullwidth="true">
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <DatePicker
                      format="DD/MM/YYYY"
                      maxDate={new Date()}
                      value={this.state.startDate.date}
                      onChange={this.handleStartDateChange('startDate')}
                      label="Start Date"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} fullwidth="true">
                <FormControl
                  style={{
                    minWidth: '70%'
                  }}
                >
                  <FormGroup className="form-input">
                    <DatePicker
                      format="DD/MM/YYYY"
                      maxDate={new Date()}
                      value={this.state.endDate.date}
                      onChange={this.handleEndDateChange('endDate')}
                      label="End Date"
                      disabled={
                        this.state.selectedVehicles.length === 0 ||
                        this.state.getAllVeh === 'true'
                      }
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <FormGroup
          className="form-input"
          style={{
            padding: '25px'
          }}
        >
          <Grid justify="left" container>
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={this.handleSubmit}
            >
              ↪ Submit
            </Button>
          </Grid>
        </FormGroup>

        <Grid item xs={12}>
          {detailedAlertsLoading ? (
            <div>Loading...</div>
          ) : this.state.isLoading ? (
            <div>Loading...</div>
          ) : (
            <MUIDataTable
              title="Detailed Alerts"
              data={this.state.response}
              columns={this.columns}
              options={{
                onDownload: this.downloadExcel
              }}
            />
          )}
        </Grid>

        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          {this.state.rawData.length > 0 && (
            <MUIDataTable
              title="Raw Data"
              data={this.state.rawData}
              columns={this.RawDatacolumns}
            />
          )}
        </Grid>
      </div>
    )
  }
}

export default withStyles(style)(withApollo(withSharedSnackbar(DetailedAlerts)))



// WEBPACK FOOTER //
// ./src/components/Pages/DetailedAlerts/index.js